import { LogLevel } from "@shopliftr/common-ng";
import { environment as baseConfig } from "./environment.base";
import { IAppConfig } from "../app/common/interfaces/app-config";

export const environment: IAppConfig = {
    ...baseConfig,
    production: true,
    staging: false,
    apiUrl: "https://internal-api.mygrocerydeals.com",
    adminAppUrl: "https://admin.mygrocerydeals.com",
    stagingAdUrl: "https://staging.ads.mygrocerydeals.com",
    publishedAdUrl: "https://ads.mygrocerydeals.com",
    publishedVideoAdUrl: "https://video.ads.mygrocerydeals.com",
    stagingAssetsUrl: "https://assets.staging.ads.mygrocerydeals.com",
    rollbar: {
        level: LogLevel.Error,
        environment: "production",
        accessToken: "a61c8914286b4a6aa29d2b49a439ad72"
    },
    newrelic: {
        enabled: true,
        trackRouteChanges: true,
        logLevel: LogLevel.Warning
    },
    authentication: {
        ...baseConfig.authentication,
        logins: []
    },
    appLinks: [{
        title: "Admin",
        url: "https://admin.mygrocerydeals.com",
        icon: "queue_play_next",
        roles: ["partner-admin"]
    }],
    displayUncaughtErrorMessage: true,
    proofsPageBaseUrl: "https://proofs.shopliftr.com",
};
